<template lang="pug">
  v-card
    v-card-title.white--text.title.primary.elevation-4
      v-layout.justify-center.align-center
        v-flex.xs10.offset-xs1.text-xs-center ASSOCIER UN COMPTE
        v-flex.xs1.text-xs-right
          v-icon(large dark @click="$emit('close')") close
    v-card-text.pb-0
      .title.pt-2 Rechercher un compte dans la base des utilisateurs
      v-layout.pb-2.compensate-scroll
        v-flex.xs3
          v-text-field.mx-3(prepend-icon="search" placeholder="Email" v-model="emailSearch" @input="value => { updateSearch('c.user_login', value) }")
        v-flex.xs3
          v-text-field.mx-3(prepend-icon="search" placeholder="Nom" v-model="nameSearch" @input="value => { updateSearch('p.name', value) }")
        v-flex.xs3
          v-text-field.mx-3(prepend-icon="search" placeholder="Ville" v-model="townSearch" @input="value => { updateSearch('p.city', value) }")
        v-flex.xs3
          v-text-field.mx-3(prepend-icon="search" placeholder="Code postal" v-model="zipSearch" @input="value => { updateSearch('p.zip', value, 'startsWith') }")
      v-divider
      v-layout.mt-3.wrap.search-results-wrapper.align-content-start(v-rc-loader="searching")
        v-layout.justify-center.align-center(v-if="!searchFilters.length && !searchResultData.values")
          .subheading.font-italic.grey--text.text--darken-1 Avant de créer manuellement un compte, cherchez d'abord si il existe déja dans la base des utilisateurs.
        v-layout.justify-center.align-center(v-if="searchFilters.length && searchResultData.values && !searchResultData.values.length")
          .subheading.font-italic.grey--text.text--darken-1 Aucun résultat ne correspond à votre recherche.
        v-flex.xs12.sm6.md4.lg3.px-3.py-2.align-self-baseline(v-for="client in searchResultData.values" :key="client.id" @click="addClient(client.id)")
          v-card.search-result.fill-height.click
            v-card-text
              v-layout
                v-flex.xs8
                  .subheading.font-weight-bold.client-name.mb-1 {{ client.name }}
                  .subheading {{ client.city }}
                  .subheading {{ client.zip }}
                v-flex.xs4
                  v-layout.justify-end.fill-height.align-center
                    v-icon(size="100") store
              v-layout.result-contacts-wrapper.pt-3
                .body-1(v-if="client.contacts_names") {{ client.contacts_names.filter(x => !!x).join(', ') }}
              v-layout.justify-end.pt-1
                .caption {{ client.siret }}
      v-layout.justify-center.align-center.pagination-wrapper
        v-pagination(v-if="(searchResultData.start > 0 || searchResultData.count > 12) && !searching" v-model="selectedPage" :length="Math.ceil(searchResultData.count / 12)" :total-visible="8" @input="getData")
      v-divider
      .new-filter-wrapper
        v-layout.justify-end.align-center.py-2(v-if="(searchFilters.length && !searching) && !((!searchResultData || !searchResultData.values) && debouncing)")
          .subheading Si vous ne trouvez pas le compte que vous recherchez vous pouvez : 
          v-dialog(v-model="fromScratchOpen" width="30%")
            v-btn(slot="activator" color="primary") Créer un compte
            v-card
              v-card-title.white--text.title.primary.elevation-4
                v-layout.justify-center.align-center
                  v-flex.xs10.offset-xs1.text-xs-center CRÉER UN COMPTE
                  v-flex.xs1.text-xs-right
                    v-icon(large dark @click="fromScratchOpen = false") close
              v-card-text
                rc-client(context="add" @close="fromScratchOpen = false; $emit('close')")
</template>

<script>
import RcClient from '@/components/RcClient/RcClient.vue';
import rcDebounce from '@/mixins/rcDebounce';
import axios from 'axios';

export default {
  components: {
    RcClient,
  },
  mixins: [
    rcDebounce
  ],
  data() {
    return {
      nameSearch: '',
      emailSearch: '',
      townSearch: '',
      zipSearch: '',
      searchResultData: {},
      searchFilters: [],
      searching: false,
      selectedPage: 1,
      fromScratchOpen: false,
      debouncing: false,
    }
  },
  methods: {
    updateSearch(field, value, operand = 'ilike') {
      this.changesearchFilters(field, value, operand);
      if (this.searchFilters.length) {
        this.debouncing = true;
        this.rcDebounce(this.getData, 1500);
      } else {
        this.searchResultData = {};
        this.debouncing = false;
      }
    },
    async getData() {
      if (this.searchFilters.length) {
        this.searching = true;
        try {
          const apiResponse = await axios.create({ headers: { 'Cache-Control' : 'no-cache' } }).post('/v2/erp/clients/search', { size: 12, start: 12 * (this.selectedPage - 1), filters: this.searchFilters });
          apiResponse.data.values = apiResponse.data.values.map(it => { it.contacts_names = [...(new Set(it.contacts_names))]; return it });
          this.searchResultData = apiResponse.data
        } catch (error) {
          this.$store.dispatch('errorHandler/throwError', { title: "La recherche n'a pas pu aboutir" });
        }
        this.debouncing = false;
        this.searching = false;
      } else {
        this.debouncing = false;
      }
    },
    async addClient(clientId) {
      this.searching = true;
      try {
        await axios.create({ headers: { 'Cache-Control' : 'no-cache' } }).post(`/v2/erp/clients/${clientId}/destination/${this.$store.state.app.destination.id}`, {});
      } catch (error) {
        this.$store.dispatch('errorHandler/throwError', { title: "Une erreur s'est produite", detail: "Le compte n'a pas pu être ajouté." });
      }
      this.$emit('added');
      this.searchResultData = {};
      this.searchFilters = [];
      this.nameSearch = '';
      this.emailSearch = '';
      this.townSearch = '';
      this.zipSearch = '';
      this.searching = false;
      this.$router.push({ name: 'client_contacts', params: { clientId: clientId }});
    },
    changesearchFilters(field, value, operand) {
      const foundParam = this.searchFilters.find(x => x.field === field);
      if (!foundParam && !!value.length) {
        this.searchFilters.push({
          field,
          value,
          operand,
        });
      } else {
        if (!value.length) {
          this.searchFilters.splice(this.searchFilters.indexOf(foundParam), 1);
        } else {
          foundParam.field = field;
          foundParam.value = value;
          foundParam.operand = operand;
        }
      }
    },
  },
}
</script>

<style lang="scss">
  .compensate-scroll {
    padding-right: 17px;
  }
  .new-filter-wrapper {
    height: 64px;
  }
  .search-results-wrapper {
    height: calc(90vh - 330px);
    overflow-y: auto;
    .search-result {
      &:hover {
        background-color: #eaeaea;
      }
    }
    .client-result {
      height: 100%;
    }
    .client-name {
      height: 48px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .pagination-wrapper {
    height: 60px;
  }
</style>
